export const SITE_NAME = "CrenelView";
export const TAGLINE = "Quiet limits on a phone you share.";
export const SITE_URL = "https://crenelview.com";
export const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.crenelview.app";
export const SUPPORT_EMAIL = "support@crenelview.com";
export const PUBLISHER = "Growthhire Enterprises";
export const OG_IMAGE = "/brand/play-feature-graphic-1024x500.png";
export const LOGO_ICON = "/brand/play-icon-512.png";
export const BLOG_CTA_HREF = "/";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "How it works", to: "/#how-it-works" },
  { label: "Privacy", to: "/privacy" },
  { label: "Blog", to: "/blog" },
  { label: "Support", to: "/support" },
];
